export const LONG_TEXT_CHARACTER_COUNT = 20
export const AFFINITY_ICONS: Record<
  'loves' | 'needs',
  Record<'url' | 'alt', string>
> = {
  loves: {
    url: '//images.babylist.com/image/upload/v1692292680/icn_preference_heart_pwgbjr.svg',
    alt: 'Heart icon for loves preference',
  },
  needs: {
    url: '//images.babylist.com/image/upload/v1692292680/icn_preference_star_rlk03g.svg',
    alt: 'Star icon for needs preference',
  },
}

// These values mirror the values in the SCSS file
export const WIDTHS = {
  desktop: {
    max: 82,
    min: 60,
  },
  mobile: {
    max: 160,
    min: 85,
  },
}

export const FONT_SIZES = {
  heading: {
    desktop: {
      max: 8,
      min: 6,
    },
    mobile: {
      max: 14,
      min: 8,
    },
  },
  content: {
    desktop: {
      max: 14,
      min: 10,
    },
    mobile: {
      max: 24,
      min: 14,
    },
  },
}

export const LONG_TEXT_MODIFIER = 0.85
